{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Tu rol no te permite {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Tu rol no te permite realizar esta acción",
    "mustHaveAtLeast8Characters": "Debe tener al menos 8 caracteres",
    "mustContainUpperCaseAndLowerCase": "Debe contener mayúsculas y minúsculas",
    "mustContainAtLeastOneLetter": "Debe contener al menos una letra",
    "mustContainAtLeastOneSpecialCharacter": "Debe contener al menos un carácter especial",
    "mustContainAtLeastOneNumber": "Debe contener al menos un número"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "Todos los permisos y control total sobre todas las cuentas.",
    "godRoleWithLessControl": "Rol GOD con menos control.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "Todos los permisos y control total sobre la cuenta de la organización.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Crear/editar/eliminar Citas, Almacenes, Tipos de Carga, Muelles y Usuarios (excepto Propietarios).",
    "createEditCancelAppointments": "Crear/editar/cancelar Citas.",
    "editAppointmentStatusTagsAndSubscribers": "Editar el estado de la cita, etiquetas y suscriptores.",
    "viewOnlyNoCreateOrEditActionsAllowed": "Solo vista. No se permiten acciones de creación o edición.",
    "carrierAdministrator": "Administrador del transportista.",
    "carrierUser": "Usuario del transportista",
    "baseUserAccount": "Cuenta de usuario base.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Conductor de almacén, tiene acceso limitado a la aplicación."
  }
}
